export default function StopButton({ isPlaying, handlePlay }) {
    return (
        <div onClick={handlePlay}>
            <svg id='stopIcon' width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="4" fill={!isPlaying? "var(--clr_purple)" : "#DFDBCE"}/>
            </svg>
        </div>

    )
}
